/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    JiraStatusInfo,
    JiraStatusInfoFromJSON,
    JiraStatusInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface JiraStatusesResponse
 */
export interface JiraStatusesResponse {
    /**
     * 
     * @type {Array<JiraStatusInfo>}
     * @memberof JiraStatusesResponse
     */
    statuses: Array<JiraStatusInfo>;
}

export function JiraStatusesResponseFromJSON(json: any): JiraStatusesResponse {
    return {
        
        'statuses': (json['statuses'] as Array<any>).map(JiraStatusInfoFromJSON),
        
    };
}

export function JiraStatusesResponseToJSON(value?: JiraStatusesResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        
        'statuses': (value.statuses as Array<any>).map(JiraStatusInfoToJSON),
        
    };
}


